import { Controller } from "stimulus";
import StimulusReflex from "stimulus_reflex";
import $ from "jquery";
import debounced from "debounced";
import throttle from "lodash/throttle";
import debounce from "lodash/debounce";
import intlTelInput from "intl-tel-input";
import { Fancybox } from "@fancyapps/ui/src/Fancybox";
import Inputmask from "inputmask";

// Import TinyMCE
import tinymce from "tinymce/tinymce";

/* import tinymce langs */
import "../src/vendor/tinymce/langs/fr_FR";
import "../src/vendor/tinymce/langs/es_419";

// Import icons
import "tinymce/icons/default/icons";

// Import theme
import "tinymce/themes/silver/theme";

// Import skin
import "tinymce/skins/ui/oxide/skin.min.css";

/* Import content css */
//import contentUiCss from 'tinymce/skins/ui/oxide/content.min.css';
//import contentCss from 'tinymce/skins/content/default/content.css';

/* tinymce plugins */
import "tinymce/plugins/advlist";
import "tinymce/plugins/anchor";
import "tinymce/plugins/autolink";
import "tinymce/plugins/autoresize";
import "tinymce/plugins/autosave";
import "tinymce/plugins/charmap";
import "tinymce/plugins/code";
import "tinymce/plugins/codesample";
import "tinymce/plugins/emoticons/js/emojis.min";
import "tinymce/plugins/emoticons";
import "tinymce/plugins/fullscreen";
import "tinymce/plugins/help";
import "tinymce/plugins/image";
import "tinymce/plugins/importcss";
import "tinymce/plugins/insertdatetime";
import "tinymce/plugins/link";
import "tinymce/plugins/lists";
import "tinymce/plugins/media";
import "tinymce/plugins/paste";
import "tinymce/plugins/preview";
import "tinymce/plugins/print";
import "tinymce/plugins/searchreplace";
import "tinymce/plugins/table";
import "tinymce/plugins/visualblocks";
import "tinymce/plugins/visualchars";
import "tinymce/plugins/wordcount";

//require ('tui-time-picker/dist/tui-time-picker.css');
//require ("tui-calendar/dist/tui-calendar.css");

//import Calendar from "tui-calendar";

//select2 plugin
require("select2/dist/css/select2");
require("select2-bootstrap-theme/dist/select2-bootstrap");
import Select2 from "select2";

/* This is your ApplicationController.
 * All StimulusReflex controllers should inherit from this class.
 *
 * Example:
 *
 *   import ApplicationController from './application_controller'
 *
 *   export default class extends ApplicationController { ... }
 *
 * Learn more at: https://docs.stimulusreflex.com
 */
export default class extends Controller {
  constructor(...args) {
    super(...args);

    this.previouslyFocusedElement = null;
  }
  connect() {
    StimulusReflex.register(this);
    window.Fancybox = Fancybox;
    if (this.identifier === "fancybox-confirmation") {
      // console.log("🛑 Ignored connect for fancybox-confirmation");
      return;
    }
    console.log(`[ApplicationController] connect depuis ${this.identifier}`);

    applyCustomColorTheme();
    this.load_show_edit_destroy();
    this.initIntTel();
    MicroModal.init({
      disableFocus: true,
    });
    initTinymce();

    var self = this;

    debounced.initialize({ input: { wait: 300 } });
    debounced.initialize({ keyup: { wait: 500 } });

    function initializeHorizontalScroller() {
      const scrollers = document.querySelectorAll(".horizontal_scroller");

      scrollers.forEach((scroller) => {
        try {
          const text = scroller.querySelector(".scrollingtext");
          if (!text || text.dataset.scrollInitialized === "true") return;

          let fluxHeader =
            scroller.closest(".flux_header") ||
            document.querySelector(".flux_header");
          if (!fluxHeader) return;

          const containerWidth = fluxHeader.offsetWidth;
          const textWidth = text.scrollWidth;

          // Appliquer le padding et l'animation uniquement si nécessaire
          text.style.paddingLeft = `${containerWidth}px`;

          const baseSpeed = 100; // pixels per second
          const duration = (textWidth + containerWidth) / baseSpeed;
          text.style.animationDuration = `${duration}s`;

          // Marque comme initialisé pour éviter les recalculs
          text.dataset.scrollInitialized = "true";
        } catch (error) {
          console.warn("⚠️ Erreur dans le scrolling horizontal :", error);
        }
      });
    }
    initializeHorizontalScroller();

    function initializeAutocompleteResultsHandler() {
      const resultContainers = document.querySelectorAll(
        "[data-autocomplete-target='results']"
      );

      resultContainers.forEach((resultsContainer) => {
        // Empêche d’attacher plusieurs fois les mêmes écouteurs
        if (!resultsContainer.dataset.listenersAttached) {
          resultsContainer.addEventListener("mousedown", (event) => {
            event.preventDefault();
            event.stopPropagation();
            console.log("🛑 Clic sur un résultat bloqué !");
          });

          resultsContainer.addEventListener("click", (event) => {
            if (event.target.tagName === "LI") {
              selectItem(event.target, resultsContainer);
            }
          });

          resultsContainer.dataset.listenersAttached = "true"; // ✅ Flag pour éviter les doubles attachements
        }
      });
    }
    initializeAutocompleteResultsHandler();

    function selectItem(element, resultsContainer) {
      const value = element.dataset.autocompleteValue;
      const label = element.dataset.autocompleteLabel;

      console.log("✅ Élément sélectionné :", label);

      // Trouver le bon parent data-controller="autocomplete"
      const autocompleteContainer = resultsContainer.closest(
        "[data-controller='autocomplete']"
      );

      if (autocompleteContainer) {
        const inputField = autocompleteContainer.querySelector(
          "[data-autocomplete-target='input']"
        );
        const hiddenField = autocompleteContainer.querySelector(
          "[data-autocomplete-target='hidden']"
        );

        if (inputField && hiddenField) {
          inputField.value = label;
          hiddenField.value = value;
        }
      }

      // Empêcher la fermeture du modal
      event.preventDefault();
      event.stopPropagation();
    }

    function templateResult(item, container) {
      // replace the placeholder with the break-tag and put it into an jquery object
      return $("<span>" + item.text.replace("[br]", "<br/>") + "</span>");
    }

    function templateSelection(item, container) {
      // replace your placeholder with nothing, so your select shows the whole option text
      return item.text.replace("[br]", "");
    }
    function initializeSelect2ContentSearch() {
      const $select = $(".content-search");

      // Vérifie si l'élément existe et n'est pas déjà initialisé
      if ($select.length && !$select.hasClass("select2-hidden-accessible")) {
        const options = {
          width: "resolve",
          placeholder: "",
          allowClear: true,
          templateResult: templateResult,
          templateSelection: templateSelection,
        };

        // Gère le cas spécial où on ne veut pas fermer après sélection
        if ($select.hasClass("no-close-select")) {
          options.closeOnSelect = false;
        }

        $select.select2(options);

        // Événements à déclencher sur sélection et désélection
        $select.on("select2:select select2:unselect", function () {
          this.dispatchEvent(new Event("change", { bubbles: true }));
        });
      }
    }
    initializeSelect2ContentSearch();

    function getParentsClassNames(elem, className) {
      var parents = [];
      while (
        elem.parentNode &&
        elem.parentNode.nodeName.toLowerCase() != "body"
      ) {
        elem = elem.parentNode;
        if (elem.className && elem.className.includes(className)) {
          parents.push(elem.className);
        }
      }
      return parents;
    }
 document.addEventListener("change", (e) => {
  e.stopImmediatePropagation();

 
  if (e.target.id === "filterrific_pf_toutes") {
    document.getElementById("filterrific_pf_toutes_hidden").value = e.target.checked ? 0 : 1;
  }
});


    document.addEventListener("click", function (evt) {
      let sidebar = document.getElementById("fx-sidebar-menu");
      if (!hasClass(sidebar, "fx-close")) {
        if (sidebar && evt.target.style.zIndex < sidebar.style.zIndex) {
          sidebar.classList.toggle("fx-close");
        }
      }
      if (self.isopened == 1 && evt.target.id != "main") {
        let condition_select2 =
          getParentsClassNames(evt.target, "select2").length == 0;
        let condition_flatpickr =
          getParentsClassNames(evt.target, "flatpickr").length == 0;

        if (
          document.getElementById("mySidebar") &&
          evt.target.style.zIndex <
            document.getElementById("mySidebar").style.zIndex &&
          condition_flatpickr &&
          condition_select2
        ) {
          self.toggle();
        }
      } else {
      }
    });

    document.addEventListener("keydown", function (evt) {
      if (self.isopened == 1) {
        let code = evt.keyCode;
        if (code == 27) {
          self.toggle();
        }
      }
    });
    function getCurrentHeight(ids) {
      let height = 0;
      for (var i = 0; i < ids.length; i++) {
        if (document.getElementById(ids[i])) {
          height = height + document.getElementById(ids[i]).offsetHeight;
        }
      }
      return height;
    }
    function hasClass(element, className) {
      return (
        (" " + element.className + " ").indexOf(" " + className + " ") > -1
      );
    }

    // Récupération des éléments html qu'on aimerait manipuler dans la fontion documentIsCrolled par le biais de leur ID
    let navbar = document.getElementById("navbar");
    let cadre = document.getElementById("onglet-cadre");
    let btl = document.getElementById("barre-titre-liste");
    let sticky = btl?.offsetTop;

    // console.log(`fx logger : ${btl}`);
    // console.log(`fx logger : ${btl}`);
    // console.log(`fx logger : ${btl}`);
    // console.log(`fx logger : ${btl}`);

    var quick_sort = document.getElementById("quick_sort");
    var search = document.getElementById("search");
    let main = document.getElementById("main");
    // let nav_bar_right_dd = document.getElementById("nav_bar_right_dd");
    let footerSection = $(".footer-section");
    if (main) {
      main.classList.add("openbtn_right");
    }
    //la ligne suivante  permet de savoir si l'utilisateur est en train de scroller la page
    window.onscroll = function () {
      if (quick_sort) {
        documentIsCrolled();
      }
    };
    /*Le but de cette fonction est de fixer le menu et certains éléments de la page
     *en haut du document quand l'utilisateur scroll vers le bas */

    function documentIsCrolled() {
      //Récupération des éléments html qu'on aimerait manipuler par le biais de leur ID
      let table1 = document.getElementById("table1");
      let cHeader = document.getElementById("c-header");
      let topSeparator = document.getElementById("top-separator-td");
      var quick_sort = document.getElementById("quick_sort");
      var search = document.getElementById("search");

      if (window.pageYOffset >= sticky - 59) {
        // if (navbar) {
        //   footerSection.css("paddingTop", "18%"
        //   );
        //   // navbar.style.paddingTop = ".20cm";
        //   navbar.classList.add("sticky");
        //   // nav_bar_right_dd.style.position = "fixed";
        // }
        if (btl) {
          btl.classList.add("sticky_header_a");
          btl.style.top = getCurrentHeight(["navbar"]) + "px";
          btl.style.zIndex = "3";
          btl.style.width = "calc(100% - 95px)";
        }
        if (cadre) {
          cadre.style.top = getCurrentHeight(["navbar"]) + "px";
          cadre.classList.add("sticky");
          cadre.style.backgroundColor = hasClass(cadre, "c_vert")
            ? "white"
            : "#9dbacc";
          cadre.style.zIndex = "3";
        }
        if (cHeader) {
          cHeader.style.top =
            getCurrentHeight(["navbar", "onglet-cadre", "top-separator-td"]) -
            "px";
          cHeader.classList.add("sticky_header");
        }
        if (topSeparator) {
          topSeparator.style.top =
            getCurrentHeight(["navbar", "onglet-cadre"]) + "px";
          topSeparator.style.position = "sticky";
        }
        if (table1) {
          table1.style.borderCollapse = "separate";
        }
        if (quick_sort) {
          quick_sort.style.top =
            getCurrentHeight(["navbar", "barre-titre-liste"]) + "px";
          quick_sort.classList.add("sticky_header");
          quick_sort.style.zIndex = "6";
        }
        if (search) {
          search.style.top =
            getCurrentHeight(["navbar", "barre-titre-liste", "quick_sort"]) +
            "px";
          search.style.zIndex = "2";
          search.style.position = "sticky";
        }

        if (main) {
          main.style.zIndex = "6";
        }
        // sticky = 59;

        // console.log(`sticky dans le if ${sticky}  et  ${window.pageYOffset}`);
      } else {
        // console.log(`sticky dans le if ${sticky}  et  ${window.pageYOffset}`);
        // if (navbar) {
        //   navbar.classList.remove("sticky");
        //   navbar.style.paddingTop = "unset";
        //   footerSection.css("paddingBottom", "unset");
        //   // nav_bar_right_dd.style.position = "";
        // }
        if (cadre) {
          cadre.classList.remove("sticky");
          cadre.style.paddingTop = "0";
          cadre.style.zIndex = "0";
        }
        if (cHeader) {
          cHeader.classList.remove("sticky_header");
          cHeader.style.top = "unset";
          cadre.style.backgroundColor = "unset";
        }
        if (topSeparator) {
          // topSeparator.classList.remove("sticky_separator");
          topSeparator.style.top = "unset";
          topSeparator.style.position = "unset";
        }
        if (btl) {
          btl.classList.remove("sticky_header_a");
          btl.style.top = "unset";
          btl.style.width = "100%";
        }
        if (table1) {
          table1.style.borderCollapse = "collapse";
        }
        if (quick_sort) {
          quick_sort.classList.remove("sticky_header");
          quick_sort.style.top = "unset";
        }

        if (search) {
          search.classList.remove("sticky");
          search.style.top = "unset";
          //search.style.zIndex = "unset";
        }
      }
    }

    ////
    $("#mySidebar #table_custom_ .switch input").each(function () {
      let me = $(this);
      if (
        me &&
        me.attr("type") === "checkbox" &&
        me.attr("class").includes("preference_columns")
      ) {
        me[0].addEventListener("change", (e) => {
          let hiddenHtmlClass = e.target.id.replace("filterrific_", "");
          // console.log(hiddenHtmlClass)
          if (e.target.checked) {
            // console.log("show ",e.target)
            $("." + hiddenHtmlClass).show();
            $("#colspan_datas").attr(
              "colspan",
              parseInt($("#colspan_datas").attr("colspan")) + 1
            );
            $("#colspan_footer").attr(
              "colspan",
              parseInt($("#colspan_footer").attr("colspan")) + 1
            );
          } else {
            // console.log("hide ",e.target)
            $("." + hiddenHtmlClass).hide();
            $("#colspan_datas").attr(
              "colspan",
              parseInt($("#colspan_datas").attr("colspan")) - 1
            );
            $("#colspan_footer").attr(
              "colspan",
              parseInt($("#colspan_footer").attr("colspan")) - 1
            );
          }
        });
      }
    });

    $(".fx-hm-sidebar .switch input.preference_columns").each(function () {
      let me = $(this);

      me.on("change", function (e) {
        let columnClass = e.target.dataset.columnKey; // Récupération de la clé de colonne
        let isChecked = e.target.checked; // État de la checkbox (coché ou non)

        console.log(columnClass);

        if (isChecked) {
          $("." + columnClass).show();
          $("#colspan_datas").attr(
            "colspan",
            parseInt($("#colspan_datas").attr("colspan")) + 1
          );
          $("#colspan_footer").attr(
            "colspan",
            parseInt($("#colspan_footer").attr("colspan")) + 1
          );
        } else {
          $("." + columnClass).hide();
          $("#colspan_datas").attr(
            "colspan",
            parseInt($("#colspan_datas").attr("colspan")) - 1
          );
          $("#colspan_footer").attr(
            "colspan",
            parseInt($("#colspan_footer").attr("colspan")) - 1
          );
        }
      });
    });
    /////
    ///// Changement de couleur design
    function hexToRgb(hex) {
      var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
      hex = hex.replace(shorthandRegex, function (m, r, g, b) {
        return r + r + g + g + b + b;
      });
      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result
        ? "rgb(" +
            parseInt(result[1], 16) +
            "," +
            parseInt(result[2], 16) +
            "," +
            parseInt(result[3], 16) +
            ")"
        : null;
    }

    function initTinymce() {
      let langs = {
        fr: "fr_FR",
        en: "en_US",
      };
      let currentLanguageElem = document.getElementById(
        "user-current-language"
      );
      let tinyLang = "fr_FR";
      if (
        currentLanguageElem !== null &&
        currentLanguageElem.value.length > 0
      ) {
        tinyLang = langs.hasOwnProperty(currentLanguageElem.value)
          ? langs[currentLanguageElem]
          : "fr_FR";
      }
      tinymce.init({
        selector: ".tinymce",
        height: 300,
        menubar: true,
        skin: false,
        content_css: false,
        language: tinyLang,
        relative_urls: false,
        remove_script_host: false,
        convert_urls: true,
        browser_spellcheck: true,   // ✅ Active le correcteur du navigateur
        gecko_spellcheck: true,     // ✅ Pour Firefox
        contextmenu: false,         // évite d'écraser le clic droit (pour afficher "Corriger l'orthographe")
        //language_url: '/packs/js/application.js',
        //content_style: contentUiCss.toString()+ "\n"+contentCss.toString(),
        plugins: [
          "advlist autolink emoticons lists link image charmap print preview anchor",
          "searchreplace visualblocks code codesample fullscreen",
          "insertdatetime media table paste code help wordcount",
        ],
        // tinymce5 toolbar items
        toolbar:
          "language|" +
          "undo redo | fontselect fontsizeselect |" +
          " bold italic underline forecolor backcolor | alignleft aligncenter " +
          " alignright alignjustify | bullist numlist outdent indent | " +
          " removeformat | help",
        // content_langs: [
        //   { title: 'English', code: 'en_US' },
        //   { title: 'French', code: 'fr_FR' },
        //   { title: 'Spanish', code: 'es_419'}
        // ],
        insertdatetime_formats: [
          "%H:%M:%S",
          "%I:%M:%S %p",
          "%d-%m-%Y",
          "%d/%m/%Y",
          "%d %B %Y",
          "%d %b %Y",
          "%Y/%m/%d",
          "%Y-%m-%d",
          "%D",
        ],
      });
    }

    function applyCustomColorTheme() {
      if ($("#condition_change_color").val() !== "true") return;

      const newColor = $("#new_color_1").val();
      const oldColors = ["#3fb0ac", "#3eb0ac"];
      const oldColor2 = "#1d5050";

      const rgbOldColors = oldColors.map(hexToRgb);
      const rgbOldColor2 = hexToRgb(oldColor2);

      $("*").each(function () {
        const $el = $(this);
        const currentColor = $el.css("color").replace(/\s/g, "");
        const currentBg = $el.css("background-color").replace(/\s/g, "");

        if (
          oldColors.includes(currentColor) ||
          rgbOldColors.includes(currentColor)
        ) {
          $el.css("color", newColor);
        } else if (
          currentColor === oldColor2 ||
          currentColor === rgbOldColor2
        ) {
          $el.css("color", newColor);
        }

        if (oldColors.includes(currentBg) || rgbOldColors.includes(currentBg)) {
          $el.css("background-color", newColor);
        } else if (currentBg === oldColor2 || currentBg === rgbOldColor2) {
          $el.css("background-color", newColor);
        }
      });

      $(".fx-table-hm.fx-table-hm-wrapped tbody tr:last-child").css(
        "border-bottom",
        `4px solid ${newColor}`
      );
    }

    //////////////////////////////////
  }

  disconnect() {
    tinymce.remove();
  }

  changeColor(event) {
    // console.log(`[ 🎨🎨 changeColor] called from ${this.identifier}`);

    function hexToRgb(hex) {
      var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
      hex = hex.replace(shorthandRegex, function (m, r, g, b) {
        return r + r + g + g + b + b;
      });
      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result
        ? "rgb(" +
            parseInt(result[1], 16) +
            "," +
            parseInt(result[2], 16) +
            "," +
            parseInt(result[3], 16) +
            ")"
        : null;
    }
    if ($("#condition_change_color").val() == "true") {
      var newColor = $("#new_color_1").val();
      var oldColor = "#3fb0ac";
      var oldColor_bis = "#3eb0ac";
      var newColor2 = $("#new_color_1").val();
      var oldColor2 = "#1d5050";
      $("*").css("color", function (i, val) {
        val = val.replace(/\s/g, "");
        if (
          val == oldColor ||
          val == hexToRgb(oldColor) ||
          val.includes(oldColor) ||
          val.includes(hexToRgb(oldColor)) ||
          val == oldColor_bis ||
          val == hexToRgb(oldColor_bis) ||
          val.includes(oldColor_bis) ||
          val.includes(hexToRgb(oldColor_bis))
        ) {
          return newColor;
        } else if (
          val == oldColor2 ||
          val == hexToRgb(oldColor2) ||
          val.includes(oldColor2) ||
          val.includes(hexToRgb(oldColor2))
        ) {
          return newColor2;
        }
      });
      $("*").css("background", function (i, val) {
        val = val.replace(/\s/g, "");
        if (
          val == oldColor ||
          val == hexToRgb(oldColor) ||
          val.includes(oldColor) ||
          val.includes(hexToRgb(oldColor)) ||
          val == oldColor_bis ||
          val == hexToRgb(oldColor_bis) ||
          val.includes(oldColor_bis) ||
          val.includes(hexToRgb(oldColor_bis))
        ) {
          return newColor;
        } else if (
          val == oldColor2 ||
          val == hexToRgb(oldColor2) ||
          val.includes(oldColor2) ||
          val.includes(hexToRgb(oldColor2))
        ) {
          return newColor2;
        }
      });
      // Vérification si l'élément existe avant d'appliquer la modification
      const lastChild = $(
        ".fx-table-hm.fx-table-hm-wrapped tbody tr:last-child"
      );
      if (lastChild.length > 0) {
        lastChild.css("border-bottom", `4px solid ${newColor}`);
      }
    }
  }

  introJsLunch(event) {
    var steps_js = eval(event.target.dataset.steps);
    steps_js = JSON.parse(steps_js);
    var new_steps = [];
    for (let i = 0; i < steps_js.length; i++) {
      if ($(steps_js[i].element).length > 0) {
        new_steps.push(steps_js[i]);
      }
    }
    steps_js = new_steps;
    var intro = introJs();
    intro.setOptions({
      steps: steps_js,
      nextLabel: event.target.dataset.next,
      prevLabel: event.target.dataset.prev,
      doneLabel: event.target.dataset.done,
      tooltipClass: "customTooltip",
    });
    intro.start();
  }
  showLoader() {
    requestAnimationFrame(function () {
      console.log("LOg requestAnimationFrame");
      $(".child-loader").show();
      document.getElementById("child-loader").style.display = "block";
    });
  }

  hideLoader() {
    setTimeout(function () {
      $(".child-loader").hide();
    }, 50);
  }
  /**
   *
   * @param {element_id} string
   */

  setPositionOfIntTel(element_id) {
    element_id = "#" + element_id + " .intl-tel-wrapper";
    document.querySelectorAll(element_id).forEach((element) => {
      this.toggleClassName(element, "p-absolute");
    });
  }

  /**
   *
   * @param {EventTarget} event

   *
   */

  slideToggle(event) {
    let element = document.getElementById("s" + event.target.id);

    this[element.style.height != "0px" ? "slideUp" : "slideDown"](element);
    this.toggleClassName(element.previousElementSibling, "active");
  }

  /**
   *
   * @param {target = HtmlSelector || HtmlElement} target
   *
   */

  getContentSize(target) {
    let container;

    if (typeof target === "string") {
      container = document.querySelector(target);
    } else if (target instanceof Element) {
      container = target;
    } else {
      console.warn(
        "Le paramètre fourni n'est ni un sélecteur valide ni un élément DOM."
      );
      return null;
    }

    if (container) {
      const width = container.scrollWidth;
      const height = container.scrollHeight;
      return { width, height };
    } else {
      console.warn("Le conteneur est introuvable.");
      return null;
    }
  }

  /**
   *
   * @param {target = HtmlSelector || HtmlElement} target
   *
   */

  getFullHeight(target) {
    let el;
    if (typeof target === "string") {
      el = document.querySelector(target);
    } else if (target instanceof Element) {
      el = target;
    } else {
      console.warn(
        "Le paramètre fourni n'est ni un sélecteur valide ni un élément DOM."
      );
      return 0;
    }
    if (!el) return 0;
    const style = window.getComputedStyle(el);
    const marginTop = parseFloat(style.marginTop) || 0;
    const marginBottom = parseFloat(style.marginBottom) || 0;
    return el.offsetHeight + marginTop + marginBottom;
  }

  /**
   *
   * @param {HTMLElement} element
   * @returns {HTMLElement}
   *
   * Cett fonction prend en paramèttre un element html
   *Elle permet de cacher l'élment reçu en paramètre en dinimiuant sa hauteure jusqu'à 0px.
   */

  slideUp(element) {
    element.style.height = this.initHeight(element) + 2 + "px";
    setTimeout(() => {
      element.style.height = "0px";
      element.style.paddingTop = "0px";
      this.setPositionOfIntTel(element.id);
    }, 100);
  }

  /**
   *
   * @param {HTMLElement} element
   * @returns  {HTMLElement}
   * Cett fonction prend en paramèttre un élément html
   *Elle permet de faire apparaître l'elément html caché à l'aide de SlideUp.
   */

  slideDown(element) {
    element.style.paddingTop = "3px";
    element.style.height = this.initHeight(element) + 2 + "px";
    setTimeout(() => {
      element.style.height = "";
      this.setPositionOfIntTel(element.id);
    }, 600);
  }

  /**
   *
   * @param {HTMLElement} element
   * @returns elementHeight
   *
   * Elle permet de savoir la hauteur initiale de l'élément qu'on doit cacher où afficher
   */

  initHeight(element) {
    let elementHeight = 0;
    for (let i = 0; i < element.childElementCount; i++) {
      elementHeight =
        elementHeight < element.children[i].offsetHeight
          ? element.children[i].offsetHeight
          : elementHeight;
    }
    return elementHeight;
  }

  /**
   *
   * @param {HmlElemnt } element
   * @returns
   *
   * Cette fonction prend en paramètre un élément html,
   * elle permet d'ajouter ou de supprimer une classe de la classeList cet élément.
   */
  toggleClassName(element, className) {
    let h1_element = $(element);
    if (h1_element.attr("class").includes(className)) {
      h1_element.removeClass(className);
    } else {
      h1_element.addClass(className);
    }

    return h1_element;
  }

 initIntTel() {
  const inputPhones = document.querySelectorAll(".int-phone");
  const errorMap = [
    "Numéro invalide",
    "Indicatif du pays invalide",
    "Trop court",
    "Trop long",
    "Numéro invalide",
  ];

  inputPhones.forEach((phone, index) => {
    if (phone.dataset.initialized === "true") return;
    phone.dataset.initialized = "true";

    const iti = intlTelInput(phone, {
      initialCountry: "fr",
      formatOnDisplay: true,
      separateDialCode: true,
      customPlaceholder: (selectedPlaceholder, selectedCountryData) => {
        const override = phone.dataset.placeholder;
        const startDigit = phone.dataset.startDigit;
        let ph = override ?? selectedPlaceholder;
        if (!override && selectedCountryData.iso2 === "fr" && startDigit) {
          ph = selectedPlaceholder.replace(/^6/, startDigit);
        }
        return `e.g. ${ph}`;
      },
    });

    const container = phone.parentElement;
    if (getComputedStyle(container).position === "static") {
      container.style.position = "relative";
    }

    // ---------- Icône + trigger tooltip ----------
    const icon = document.createElement("i");
    icon.className = "fa";
    icon.style.fontSize = "1.2em";

    const trigger = document.createElement("span");
    trigger.setAttribute("data-controller", "tooltip");
    trigger.style.position = "absolute";
    trigger.style.top = "50%";
    trigger.style.transform = "translateY(-50%)";
    trigger.style.right = "-20px";
    trigger.style.cursor = "pointer";
    trigger.appendChild(icon);
    container.appendChild(trigger);

    // cible tooltip unique
    const base =
      (phone.id && phone.id.trim()) ||
      (phone.name && phone.name.replace(/\W+/g, "_")) ||
      `intphone_${index}`;
    let tipContent = document.createElement("div");
    let tipId = `tip_${base}_${Date.now()}`;
    tipContent.id = tipId;
    tipContent.style.display = "none";
    container.appendChild(tipContent);
    trigger.setAttribute("data-tooltip-target-id-value", tipId);

    // hidden éventuel
    const hiddenInput = document.getElementById(`tel_${index}`);

    // helpers tooltip
    const closeTooltip = () => {
      trigger.dispatchEvent(new Event("mouseleave", { bubbles: true }));
      icon.dispatchEvent(new Event("mouseleave", { bubbles: true }));
    };
    const openTooltip = () => {
      icon.dispatchEvent(new Event("mouseenter", { bubbles: true }));
      trigger.dispatchEvent(new Event("mouseenter", { bubbles: true }));
    };

    // util: état disabled
    const isDisabled = () =>
      phone.matches(":disabled") || phone.getAttribute("aria-disabled") === "true";

    // clé: recréer la cible et repointer (force ton contrôleur à relire)
    const setTip = (html) => {
      const hovered = trigger.matches(":hover") || icon.matches(":hover");
      closeTooltip();

      const newId = `tip_${base}_${Date.now()}`;
      const newContent = document.createElement("div");
      newContent.id = newId;
      newContent.style.display = "none";
      newContent.innerHTML = html || "";

      if (tipContent.parentNode) {
        tipContent.parentNode.replaceChild(newContent, tipContent);
      } else {
        container.appendChild(newContent);
      }
      tipContent = newContent;
      tipId = newId;
      trigger.setAttribute("data-tooltip-target-id-value", tipId);

      if (hovered && tipContent.textContent.trim() !== "") {
        requestAnimationFrame(openTooltip);
      }
    };

    const clearHidden = () => {
      if (hiddenInput) hiddenInput.value = "";
    };

    const resetUI = () => {
      phone.classList.remove("error");
      icon.className = "fa";
      icon.style.color = "";
      setTip("");      // vide & ferme
      clearHidden();
    };

    const validate = () => {
      // ne rien faire si le champ est disabled
      if (isDisabled()) {
        resetUI();
        // feedback visuel léger (optionnel)
        icon.style.opacity = "0.4";
        closeTooltip();
        return;
      }
      icon.style.opacity = ""; // re-enable visuel si réactivé

      const wasHovered = trigger.matches(":hover") || icon.matches(":hover");
      resetUI();
      if (!phone.value.trim()) return;

      if (iti.isValidNumber()) {
        icon.classList.add("fa-check-circle");
        icon.style.color = "green";
        setTip("Numéro valide");
        if (hiddenInput) hiddenInput.value = iti.getNumber();
      } else {
        phone.classList.add("error");
        icon.classList.add("fa-exclamation-circle");
        icon.style.color = "red";
        const err = iti.getValidationError();
        setTip(errorMap[err] || "Numéro invalide");
        clearHidden();
      }

      if (!wasHovered) closeTooltip();
    };

    // events
    phone.addEventListener("blur", validate);
    phone.addEventListener("keyup", validate);
    phone.addEventListener("change", validate);
    phone.addEventListener("countrychange", () => {
      if (isDisabled()) { resetUI(); return; }
      resetUI();
      validate();
    });

    // observe changement d’attribut disabled (dynamiquement)
    const mo = new MutationObserver((mutations) => {
      mutations.forEach((m) => {
        if (m.attributeName === "disabled" || m.attributeName === "aria-disabled") {
          if (isDisabled()) {
            resetUI();
            icon.style.opacity = "0.4";
          } else {
            icon.style.opacity = "";
            validate();
          }
        }
      });
    });
    mo.observe(phone, { attributes: true, attributeFilter: ["disabled", "aria-disabled"] });

    // init
    if (!isDisabled() && phone.value.trim()) validate(); else resetUI();
  });
}
 
  /**
   * @name  get_browser
   * @returns
   * Cette fonction permet de savoir le navigateur qu'utilise l'utilisateur
   */

  get_browser() {
    let ua = navigator.userAgent,
      tem,
      M =
        ua.match(
          /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
        ) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return { name: "IE", version: parseInt(tem[1]) || "" };
    }
    if (M[1] === "Chrome") {
      tem = ua.match(/\bOPR|Edge\/(\d+)/);
      if (tem != null) {
        return { name: "Opera", version: parseInt(tem[1]) };
      }
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) {
      M.splice(1, 1, tem[1]);
    }
    return {
      name: M[0],
      version: parseInt(M[1]),
    };
  }

  reset(error, valid, phoneInput, hidden_field, iti) {
    phoneInput ? phoneInput.classList.remove("error") : "";
    error ? (error.innerHTML = "") : "";
    error ? error.classList.add("hide") : "";
    valid ? valid.classList.add("hide") : "";
    hidden_field ? (hidden_field.value = iti.getNumber()) : "";
  }

  initZindex() {
    let index = [
      ...document.querySelectorAll("#mySidebar DIV"),
      ...document.querySelectorAll("#mySidebar INPUT"),
      ...document.querySelectorAll("#mySidebar I"),
      ...document.querySelectorAll("#mySidebar SPAN"),
      ...document.querySelectorAll("#mySidebar A"),
    ];

    for (let j = 0; j < index.length; j++) {
      index[j].style.zIndex = 100;
    }
  }

  toggle() {
    if (this.isopened != 3) {
      this.initZindex();
      this.isopened = 3;
      this.fct($("#mySidebar").css("width") > "0px").then((res) => {
        if (res == true) {
          this.isopened = 1;
        } else {
          this.isopened = 0;
        }
      });
    } else {
      /*********/
    }
  }

  iniFla() {
    let fields = document.querySelectorAll(".flatpickr");

    for (let j = 0; j < fields.length; j++) {
      fields[j].classList.add("fx-input-date-sidbar-menu");
    }
  }
  fct(isopened) {
    return new Promise((resolve, reject) => {
      const tableCustom = document.getElementById("table_custom_");

      if (isopened) {
        // Fermer le sidebar et masquer `#table_custom_` de manière fluide
        if (tableCustom && tableCustom.classList.contains("visible")) {
          tableCustom.style.height = tableCustom.scrollHeight + "px"; // Définir la hauteur actuelle
          tableCustom.offsetHeight; // Forcer le reflow
          tableCustom.style.height = "0"; // Transition vers 0
          tableCustom.style.opacity = "0"; // Transition de l'opacité
          setTimeout(() => {
            tableCustom.classList.remove("visible");
            tableCustom.style.display = "none"; // Assure que l'élément est masqué
          }, 400); // Durée de la transition
        }

        this.closeNav().then(() => {
          setTimeout(function () {
            $("#mySidebar").css("position", "unset");
            $("#main").css("position", "unset");
            main.classList.remove("openbtn_left");
            main.classList.add("openbtn_right");
            $("#mySidebar").css("display", "none");
            resolve(false);
          }, 500);
        });
      } else {
        // Ouvrir le sidebar et afficher `#table_custom_` de manière fluide
        this.openNav().then(() => {
          $("#mySidebar").css("position", "absolute");
          $("#main").css("position", "absolute");
          $("#main").css("marginTop", "0px");
          $("#mySidebar").css("display", "block");
          main.classList.add("openbtn_left");
          main.classList.remove("openbtn_right");

          if (tableCustom && !tableCustom.classList.contains("visible")) {
            tableCustom.style.display = "block"; // Rendre visible
            tableCustom.offsetHeight; // Forcer le reflow
            tableCustom.style.height = tableCustom.scrollHeight + "px"; // Transition vers la hauteur calculée
            tableCustom.style.opacity = "1"; // Transition de l'opacité
            tableCustom.classList.add("visible");
            setTimeout(() => {
              tableCustom.style.height = "auto"; // Permettre un ajustement dynamique après la transition
            }, 400); // Durée de la transition
          }

          resolve(true);
        });
      }
    });
  }

  openNav() {
    return new Promise((resolve, reject) => {
      document.getElementById("mySidebar").style.width = "366.8px";
      document.getElementById("main").style.marginRight = "366.8px";
      resolve(true);
    });
  }

  closeNav() {
    return new Promise((resolve, reject) => {
      document.getElementById("mySidebar").style.width = "0px";
      document.getElementById("main").style.margin = "0px";
      resolve(true);
    });
  }

  rerender() {
    var row = $("#search");
    var row2 = $("#quick_sort");
    row.insertAfter(row2);
  }

  /**
   * @name load_show_edit_destroy
   * Cette fonction permet d'afficher ou de cacher les boutons ajouter éditer est supprimé des lignes des tableaux de vueListe
   */
  load_show_edit_destroy() {
    var self = this;
    $(function () {
      self.show_edit_destroy_mouse_hover();
      $("#bd").change(function () {
        self.show_edit_destroy_mouse_hover();
      });
    });
  }

  mask_on_dates() {
    console.log("! Mask on dates activated reflex callbacks!");
    const elements = document.getElementsByClassName("date_mask");
    Array.from(elements).forEach((element) => {
      const initialValue = element.value;
      // Check if the initial value is in "aaaa-mm-dd" format
      if (/^\d{4}-\d{2}-\d{2}$/.test(initialValue)) {
        // Format the initial value from "aaaa-mm-dd" to "dd/mm/yyyy"
        const formattedValue = initialValue
          .split("-")
          .reverse()
          .join("/")
          .replace(/-/, "/");

        // Set the formatted value back to the element
        element.value = formattedValue;
      }
      Inputmask({
        alias: "datetime",
        inputFormat: "dd/mm/yyyy", // Specify the input format of your initial dates
        placeholder: "__/__/____",
        showMaskOnHover: false,
      }).mask(element);
    });
  }

  /**
   * @name show_edit_destroy_mouse_hover
   * Cette fonction permet d'afficher ou de cacher les boutons ajouter éditer est supprimé des lignes des tableaux de vueListe
   */

  show_edit_destroy_mouse_hover() {
    $("#table1 tbody td:not(#search)").hover(
      function () {
        if ($(this).parents("tr").attr("id") != "search") {
          $(this).parents("tr").addClass("highlight");
        }
      },
      function () {
        if ($(this).parents("tr").attr("id") != "search") {
          $(this).parents("tr").removeClass("highlight");
        }
      }
    );

    // fonction du tableau pour cacher ou montrer les boutons actions par rangees
    $("a.edit").hide(); // cacher les liens avec la classe edit
    $("img.edit").hide(); // cacher les liens avec la classe edit
    $("a.show").hide(); // cacher les liens avec la classe show
    $("img.show").hide(); // cacher les liens avec la classe show
    $("a.destroy").hide(); // cacher les liens avec la classe destroy
    $("img.destroy").hide(); // cacher les liens avec la classe destroy
    //
    // effet sur chaque rangee du tableau avec id

    $("#table1 tr:not(#search)").hover(
      function () {
        $(this).find("a.edit").addClass("selected").show();
        $(this).find("img.edit").addClass("selected").show();
        $(this).find("a.show").addClass("selected").show();
        $(this).find("img.show").addClass("selected").show();
        $(this).find("a.destroy").addClass("selected").show();
        $(this).find("img.destroy").addClass("selected").show();
      },
      function () {
        $(this).find("a.edit").removeClass("selected").hide();
        $(this).find("img.edit").removeClass("selected").hide();
        $(this).find("a.show").removeClass("selected").hide();
        $(this).find("img.show").removeClass("selected").hide();
        $(this).find("a.destroy").removeClass("selected").hide();
        $(this).find("img.destroy").removeClass("selected").hide();
      }
    );
  }

  togglePassword() {
    const passwordInput = document.getElementById("password");
    const eyeIcon = document.getElementById("eye_icon");
    eyeIcon.classList.toggle("la-eye-slash");
    if (passwordInput.type === "password") {
      passwordInput.type = "text";
    } else {
      passwordInput.type = "password";
    }
  }

  /* Application-wide lifecycle methods
   *
   * Use these methods to handle lifecycle concerns for the entire application.
   * Using the lifecycle is optional, so feel free to delete these stubs if you don't need them.
   *
   * Arguments:
   *
   *   element - the element that triggered the reflex
   *             may be different than the Stimulus controller's this.element
   *
   *   reflex - the name of the reflex e.g. "Example#demo"
   *
   *   error/noop - the error message (for reflexError), otherwise null
   *
   *   reflexId - a UUID4 or developer-provided unique identifier for each Reflex
   */
  beforeReflex(element, reflex, noop, reflexId) {
    console.log("before reflex callback in stimulus");
    if (
      $(".content-search") &&
      !$(".content-search").hasClass("select2-hidden-accessible")
    ) {
      if ($(".content-search").hasClass("no-close-select")) {
        $(".content-search").select2({
          width: "resolve",
          placeholder: "",
          allowClear: true,
          closeOnSelect: false,
        });
      } else {
        $(".content-search").select2({
          width: "resolve",
          placeholder: "",
          allowClear: true,
        });
      }
    }
    $(".content-search").on("select2:select", function () {
      let event = new Event("change", { bubbles: true }); // fire a native event
      this.dispatchEvent(event);
    });
    MicroModal.init({
      disableFocus: true,
    });
    this.changeColor();
    //this.previouslyFocusedElement = document.activeElement;
    this.mask_on_dates();
  }
  afterReflex(element, reflex, noop, reflexId) {
    console.log("After reflex callback in stimulus");
    if (
      $(".content-search") &&
      !$(".content-search").hasClass("select2-hidden-accessible")
    ) {
      if ($(".content-search").hasClass("no-close-select")) {
        $(".content-search").select2({
          width: "resolve",
          placeholder: "",
          allowClear: true,
          closeOnSelect: false,
        });
      } else {
        $(".content-search").select2({
          width: "resolve",
          placeholder: "",
          allowClear: true,
        });
      }
    }
    $(".content-search").on("select2:select", function () {
      let event = new Event("change", { bubbles: true }); // fire a native event
      this.dispatchEvent(event);
    });
    MicroModal.init({
      disableFocus: true,
    });
    this.changeColor();
    //this.previouslyFocusedElement.focus();
    this.mask_on_dates();
  }
  // Save a reference to the element that should receive focus
  reflexSuccess(element, reflex, noop, reflexId) {
    console.log("success reflex callback in stimulus");
    if (
      $(".content-search") &&
      !$(".content-search").hasClass("select2-hidden-accessible")
    ) {
      if ($(".content-search").hasClass("no-close-select")) {
        $(".content-search").select2({
          width: "resolve",
          placeholder: "",
          allowClear: true,
          closeOnSelect: false,
        });
      } else {
        $(".content-search").select2({
          width: "resolve",
          placeholder: "",
          allowClear: true,
        });
      }
    }
    $(".content-search").on("select2:select", function () {
      let event = new Event("change", { bubbles: true }); // fire a native event
      this.dispatchEvent(event);
    });
    MicroModal.init({
      disableFocus: true,
    });
    this.changeColor();
    this.mask_on_dates();
  }

  reflexError(element, reflex, error, reflexId) {
    console.log("Error reflex callback in stimulus");
    if (
      $(".content-search") &&
      !$(".content-search").hasClass("select2-hidden-accessible")
    ) {
      if ($(".content-search").hasClass("no-close-select")) {
        $(".content-search").select2({
          width: "resolve",
          placeholder: "",
          allowClear: true,
          closeOnSelect: false,
        });
      } else {
        $(".content-search").select2({
          width: "resolve",
          placeholder: "",
          allowClear: true,
        });
      }
    }
    $(".content-search").on("select2:select", function () {
      let event = new Event("change", { bubbles: true }); // fire a native event
      this.dispatchEvent(event);
    });
    MicroModal.init({
      disableFocus: true,
    });
    this.changeColor();
    this.mask_on_dates();
  }

  afterRemovePref(element) {
    console.log("afterRemovePref afterRemovePref afterRemovePref");
    $(".child-loader").show();
    $("#filterrific_filter").submit();
  }

  beforeRemovePref(element) {
    console.log("afterRemovePref afterRemovePref afterRemovePref");
    $(".child-loader").show();
    $("#filterrific_filter").submit();
  }

  urlContainsSegment(segment) {
    const url = new URL(window.location.href);
    const pathSegments = url.pathname.split("/").filter(Boolean);

    return pathSegments.includes(segment);
  }

  handleSidebarScroll(elementPrefix) {
    var sidebarId = "mySidebar";
    var scrollLevelId = "scrollevel";

    // Vérification que l'élément de la barre latérale existe
    var targetElement = document.getElementById(sidebarId);
    if (!targetElement) {
      console.warn(`Élément avec l'ID "${sidebarId}" introuvable.`);
      return;
    }

    // Ajout de l'événement de défilement
    targetElement.addEventListener("scroll", () => {
      const scrollLevelElement = document.getElementById(scrollLevelId);
      if (scrollLevelElement) {
        console.log("From controller.js =======> ", targetElement.scrollTop);
        scrollLevelElement.value = targetElement.scrollTop;
      } else {
        console.warn(`Élément avec l'ID "${scrollLevelId}" introuvable.`);
      }
    });

    // Gestion du paramètre URL
    const currentUrl = window.location.href;
    const url = new URL(currentUrl);
    const recordParam = url.searchParams.get("previous_record");

    if (recordParam) {
      var trElement = $("#" + elementPrefix + recordParam);

      // Vérification de l'existence de l'élément cible
      if (trElement.length > 0) {
        trElement.find("td").addClass("highlighted-td");
        trElement
          .get(0)
          .scrollIntoView({ behavior: "smooth", block: "center" });
      } else {
        console.warn(
          `Élément avec le préfixe "${elementPrefix}${recordParam}" introuvable.`
        );
      }
    } else {
      console.warn("Aucun paramètre 'previous_record' trouvé dans l'URL.");
    }
  }
}
